import React from 'react';
import { CanViewRosters } from 'library/permissions';
import { history } from 'store';
import { getActiveIcon } from 'library/helpers';
import { Button } from 'antd';
import RosterVersionInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Version Name',
        dataIndex: 'name',
        key: 'name',
        width: '350px',
        align: 'left',
        sorter: true
      },
      {
        title: 'Published',
        dataIndex: 'is_published',
        width: '120px',
        align: 'center',
        render: (text, record) => getActiveIcon(record.is_published)
      },
      {
        title: '',
        key: 'manage',
        align: 'left',
        render: data => (
          <div className="bhp-item-commands">
            {CanViewRosters()
              .hasPermissions() && (
              <Button type="primary" size="small" onClick={() => history.push(`/roster/detail/${data.id}`)}>Manage Timeline</Button>
            )}
          </div>
        )
      }
    ],
    isRecordDeletable: record => !record.is_published,
    isRecordEditable: record => !record.is_published,
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the version ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'is_published',
      order: 'descend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Roster Versions',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Roster',
    title: 'Roster Version',
    component: props => (
      <RosterVersionInput
        {...props}
        title="Roster Version"
      />
    )
  }
};

export default config;
